<template>
  <div class="p-4">
    <div class="stack" v-if="user">
      <h2>{{ user.username }}</h2>
      <info :title="$t('users.request.message_required')" toggleable>{{
        $t("users.request.message_required_info")
      }}</info>
      <input-textarea
        type="textarea"
        :label="$t('general.message')"
        required
        @update-value="updateForm('message', $event)"
      />
      <div class="text-right">
        <wd-button :disabled="!formData.message" @input="submit(formOptions)">{{
          $t("general.send")
        }}</wd-button>
      </div>
    </div>
    <div v-else>{{ $t("users.request.no_user_found") }}</div>
  </div>
</template>

<script>
const Info = require("@/modules/core/components/Info.vue").default;
const InputTextarea = require("@/modules/input/components/InputTextarea.vue")
  .default;

import FormMixin from "@/mixins/FormMixin";

export default {
  name: "FriendRequestSite",
  mixins: [FormMixin],
  data() {
    return {
      user: null,
    };
  },
  props: {
    id: {
      default: null,
      type: String,
    },
  },
  components: {
    InputTextarea,
    Info,
  },
  methods: {
    // async sendRequest() {
    //   await this.$store.getters["userfriendrequest/api"]
    //     .Create(this.formData)
    //     .then(result => {
    //       this.goTo("/friends");
    //       this.popup({
    //         title: "Freundschaftsanfrage gesendet",
    //         text:
    //           this.user.username +
    //           " wurde eine Freundschaftsanfrage zugeschickt."
    //       });
    //     });
    // }
  },
  computed: {},
  async created() {
    this.formData.to = this.id;
    this.formOptions = {
      async: true,
      type: "userfriendrequest",
      call: "create",
      action: (response) => {
        this.goTo("/friends");
        this.popup({
          title: this.$t("users.request.friend_request_sent"),
          text: this.$t("users.request.friend_request_sent_message", {
            user: this.user.username,
          }),
        });
      },
    };
    this.user = await this.$store.getters["users/api"].Custom.User(this.id);
    this.updateForm(this.id, "to");
  },
  mounted() {
    this.$store.dispatch("header/update", {
      clear: true,
      elements: [
        {
          value: this.$t("users.request.friend_request"),
          css: "font-medium tracking-wider",
          location: "left",
        },
      ],
      backbutton: true,
    });
  },
};
</script>
